import sha1 from "js-sha1";

const BlankCutEditorBaseValues = {
  basicAmount: 7,
  pricePerSqm: 10,
  surchargeUnderglass: {
    fix: 0,
    percentage: 0,
  },
  sections: ["size", "vinyl", "color"],
};

const extractFormState = (formState) => {
  if (formState) {
    let svgJson = {};
    svgJson.width = formState.width;
    svgJson.height = formState.height;
    svgJson.amount = formState.amount;
    svgJson.materialSerie = formState.materialSerie;
    svgJson.color = formState.color;

    return {
      materialSerie: formState.materialSerie,
      color: formState.color,
      size: formState.size,
      svgJson,
    };
  } else {
    return {};
  }
};

function getFoilBasePrice(formValues) {
  let price = 10; // fallback value

  let highestPrice =
    formValues && formValues.color && formValues.color.value
      ? formValues.color.value.price_per_sqm
      : 0;
  price = highestPrice > 0 ? highestPrice : price;
  return price;
}

function getSurfaceSizeForPrice(formValues) {
  let { width, height, color } = formValues;
  width = parseInt(width); // ensure Int for comparision
  height = parseInt(height); // ensure Int for comparision
  let surfaceSize = ((width / 10) * (height / 10)) / 10000;
  // convert mm to cm (/10), convert sqCM to sqM (/10000)
  // return ((width / 10 + border.border) * (height / 10 + border.border)) / 10000;
  const roll_width = color ? color.value.roll_width || 1260 : 1260;

  // Does not match default size
  if (width !== roll_width && height !== roll_width) {
    // Check if both exceed size
    if (width > roll_width && height > roll_width) {
      // Both exceed, add 15% additional size for waste
      surfaceSize = (((width / 10) * (height / 10)) / 10000) * 1.15;
    } else {
      // only one exceeds or non exceeds, let's check for calculation what is closer to roll_width
      if (roll_width - width > roll_width - height) {
        // 1260 - 2000 = -740 > 1260 - 500 = 760
        if (roll_width > height) {
          surfaceSize = ((width / 10) * (roll_width / 10)) / 10000;
        } else {
          surfaceSize = ((roll_width / 10) * (height / 10)) / 10000;
        }
      } else {
        if (roll_width > width) {
          surfaceSize = ((roll_width / 10) * (height / 10)) / 10000;
        } else {
          surfaceSize = ((width / 10) * (roll_width / 10)) / 10000;
        }
      }
    }
  }
  return surfaceSize;
}

const calculatePrice = (formValues) => {
  let price = 0;
  const editorBasePrice = BlankCutEditorBaseValues.basicAmount;
  const foilBasePrice = getFoilBasePrice(formValues);
  const surfaceSize = getSurfaceSizeForPrice(formValues);

  price += editorBasePrice + foilBasePrice * surfaceSize;

  // let maxDiscount = {};
  let currentDiscount = {};
  if (BlankCutEditorBaseValues.discounts) {
    BlankCutEditorBaseValues.discounts.forEach((discount) => {
      if (discount.amount <= formValues.amount) {
        currentDiscount = discount;
      }
    });
    // maxDiscount = BlankCutEditorBaseValues.discounts[BlankCutEditorBaseValues.discounts.length - 1];
  }
  price += price * 0.05;
  const priceBeforeDiscountAndTax = price + 0;
  const displayPrice =
    price -
    (currentDiscount.percentage
      ? (price * currentDiscount.percentage) / 100
      : 0);
  const Vat = Math.round(displayPrice * 0.19 * 100) / 100;
  const finalPrice = Math.round((displayPrice + Vat) * 100) / 100;
  return { displayPrice, finalPrice, Vat, priceBeforeDiscountAndTax };
};

function uniqueId(length) {
  let id;
  id = "";
  while (id.length < length) {
    id += Math.random().toString(36).substr(2);
  }
  return id.substr(0, length);
}

function generateSKU() {
  const slug = "blankcut";
  return slug + "_" + uniqueId(25);
}

function generateChecksum() {
  const checksum = sha1("hash me");
  return checksum;
}

function generateDescriptionText(state, translations) {
  let description = "";

  BlankCutEditorBaseValues.sections.forEach((section) => {
    switch (section) {
      case "size":
        description += `${translations.width}: ${Math.floor(state.width)}mm (${(
          state.width / 10
        ).toFixed(1)}cm) x `;
        description += `${translations.height}: ${Math.floor(
          state.height
        )}mm (${(state.height / 10).toFixed(1)}cm) | `;
        break;
      case "vinyl":
        description +=
          translations.material + ": " + translations.series + " | ";
        break;
      case "color":
        const selectedColor = state.color.value;
        description += `${translations.color}: ${selectedColor.title} (${translations.series}) | `;
        break;
      default:
        description +=
          "Fehlende Sektion {section}. Bitte kontaktieren Sie den Kundendienst: hilfe@myfolie.com.: " +
          section +
          " | ";
        break;
    }
  });

  return description.slice(0, -3);
}

const generateJson = (state, lang, translations) => {
  const calculatedPrice = calculatePrice(state);
  return {
    width: state.width,
    amount: state.amount || 1,
    height: state.height,
    origin: lang,
    productTitle: translations.title,
    description: generateDescriptionText(state, translations),
    vinyl: state.materialSerie,
    color: state.color.value,
    editorType: 22,
    sku: generateSKU(),
    price: calculatedPrice["finalPrice"],
    priceBeforeDiscountAndTax: calculatedPrice["priceBeforeDiscountAndTax"],
    depth: generateChecksum(),
  };
};

const formHelpers = {
  extractFormState: extractFormState,
  calculatePrice: calculatePrice,
  generateJson: generateJson,
};

export default formHelpers;
